<template>
<div  class="container-fluid" >
  
  
  <div class="card ">
  
  <div class="card-header text-white  bg-primary">    
      <h4><i  class="fas fa-list-alt mr-2" aria-hidden="true"></i>AGGIORNAMENTO LISTINO DI VENDITA</h4>    
  </div>
  
  <div class="card-body"> 
  
   <div class="row">
   <div class="col-sm-auto"> 

   <div class="card border-info" >
   <div class="card-header bg-info">
      
      

  <strong>PARAMETRI RICERCA</strong></div>


  <div class="card-body text-info">
  <!--    
  <button type="button" @click ="type=!type" class="btn btn-outline-info mb-4" data-toggle="button" aria-pressed="false">
  {{type ? 'Altri parametri di ricerca':'Ricerca per barcode'}}
  </button>  
  -->


  <div v-if="type" class="form-group ">
        <form class="mb-3" v-on:submit.prevent="getDataByBarcode()">
        <label class="" for="codiceArticolo"><strong>
          <i style="color:black" class="fas fa-barcode mr-2" aria-hidden="true"></i>
          Codice a barre prodotto</strong></label>      
        <input v-focus type="text"   class="form-control " id="barcode" autocomplete="off" placeholder="Digitare un codice a barre prodotto e premere invio." v-model="barcode">
        <small id="codeBlock" class="form-text text-muted">
        Formato ammesso EAN13.
        </small>
        </form>

        <input-file v-bind:type="'PriceListUpdate'" @update="getDataFromFile"></input-file>
        
  </div>   
  <div v-else>
  <form name="productSearch" v-on:submit.prevent="getDataByParams()">


        <div class="form-group">                
          <supplier-select v-bind:required="true" v-bind:isActive="true" @update="setSupplierId"></supplier-select>
        </div>
  
  
        <div class="form-group">
            <category-grouping v-bind:required="true"  v-bind:isActive="true" @update="setGroupCategoryId"></category-grouping>  
        </div>
  
  
        <div class="form-group">
            <category-select  v-bind:isActive="true" @update="setCategoryId"></category-select>  
        </div>
  
  
        <div class="form-group">
            <department-select v-bind:required="true" v-bind:type="true"  v-bind:isActive="true" @update="setDepartmentId"></department-select>  
        </div>
  


  
        <div class="form-group">
            <season-select v-bind:required="true"  v-bind:type="true"  v-bind:isActive="true" @update="setSeasonId"></season-select>      
        </div>
  

      <div class="form-group">
         <year-select v-bind:_label="label1" v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYearStart"></year-select>      
      </div>  
  
  
      <div class="form-group">
         <year-select  _id="0" v-bind:_label="label2" v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYearEnd"></year-select>      
      </div>
     <button  class="btn btn-primary float-right " type="submit">
       <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      CERCA
      <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
      </button>

  </form>
  </div>
  </div>
  </div>
  </div>

  <div class="col">

 
 


 <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

 <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-hover table-sm table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col"></th>
        <th scope="col">#</th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">CODICE</th>
        <th scope="col">CATEGORIA</th>
        
        
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">PREZZO</th>
        <th scope="col">SCONTO</th>
        <th scope="col">COLORE(I)</th>
       
      </tr>
    </thead>
    <tbody>
      
      <tr data-toggle="tooltip" title="doppio click colori e sconto" @dblclick="setProductColorList(item.productId,index)" class="pointer" v-for="(item, index) in filteredItems" :key="index">
        <td>
           <input  class="pointer" type="checkbox"  v-model.number="item.selected">
           
          </td> 
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.line}}</td>
        <td>{{item.sku}}
        
         <div v-if="isOpen[index]==true">
          <component v-bind:is="component" v-bind:promoId="promoId" v-bind:productId="productId" @close="isOpen=[]"></component>    
          
          <span v-if="spinner1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
          </div>
        
        </td>
        <td>{{item.category}}</td>        
        
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td class="text-right">{{fmt1(item.price)}} </td>
         
        
        <td>{{item.discount}}</td>
        <td>{{item.colorList}}</td>
       
      </tr> 
      
      
    </tbody>
    
  </table>
 </div>


<label for="filter">
  <i class="fas fa-filter mr-2" aria-hidden="true"></i>
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
<div class="mt-2">
<button @click="resetSelection()" type="button"   class="btn btn-outline-dark float-left mt-1 mb-2 mr-4 ml-4">                    
          ELIMINA SELEZIONE ARTICOLI
          <i class="fas fa-trash ml-2 mr-2" aria-hidden="true"></i>
</button>


<button @click="setSelection(1)" type="button"   class="btn btn-outline-secondary float-left mt-1 mb-2 mr-2">                    
        SELEZIONA TUTTO
          <i class="fas fa-edit ml-2 mr-2" aria-hidden="true"></i>
</button>


<button @click="setSelection(0)" type="button"   class="btn btn-outline-secondary float-left mt-1 mb-2 mr-2">                    
        DESELEZIONA TUTTO
          <i class="far fa-edit ml-2 mr-2" aria-hidden="true"></i>
</button>
</div>
  </div>  



  </div>



  <div class="row">
  <div class="col">      

    <div class="form-group float-right">
      <label for="Input7"><strong>Prezzo di vendita</strong></label>
      <input  type="number" step="0.01" class="form-control" v-model="price" >
    </div>

  </div>
  </div>


</div>


</div>


    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
    </confirm-box>


     <confirm-box v-if="cbReset.show">     
      <template v-slot:header>
        <strong>{{cbReset.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cbReset.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cbReset.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="items=[],cbReset.show=false" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>    


<div class="custom-file">




</div>
 <button type="button" :disabled="filteredItems.length==0 || bt_spinner2 == true || isOpen.length>0"  @click="saveData()" class="btn btn-success float-right mt-1 mr-3">
   
   CONFERMA AGGIORNAMENTO LISTINO 
    <span v-if="bt_spinner2" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
   </button>


</div>


</template>
<script>

import api               from "@/api";
import alertBox          from '@/components/common/AlertBox.vue'
import confirmBox        from '@/components/common/ConfirmBox.vue';
import inputFile         from '@/components/common/InputFile.vue';
import {mapGetters }     from 'vuex';
import fmt               from '@/components/mixins/fmt.js'

export default {
  props      : ['promoId'],
  
  components  : {alertBox,confirmBox,inputFile},
  mixins :[fmt],
  data() {
    return {
    
    type                   : true,
    barcode                : '',
    product                : {},
    items                  : [],

    msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
    bt_spinner1             : false, 
    bt_spinner2             : false, 
    discount               : 0 ,
    price                  : 0,
    filterKey              : '' ,
    cb                     : {title : '',msg1 : '',show:false},
    cbReset                : {title : '',msg1 : '',show:false},
    promo                  : {},
    label1                 : 'da ',
    label2                 : 'ad ',
    colorList              : [],
    productId              : 0,
    isOpen                 : [],
    componentKey           : 0,
    component              : '',
    spinner1               : false,
    ean                   : []

   
    
     
    }
  },
  computed :{
   
     ...mapGetters(['company']),
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
   mounted : function()
  {

    //this.getPromo()
    
  },

  beforeDestroy () {
   
  
        /*$(document).scannerDetection(false);*/
    },
  

  created: function() {
    


  },
  methods: {

   
    setProductColorList()
    {

    },

   
    resetSelection()
    {
      if(this.items.length>0)
      {
        this.cbReset.title = 'ELIMINA SELEZIONE ARTICOLI'
        this.cbReset.msg1 = 'Si desidera eliminare la selezione articoli ?'
        this.cbReset.show = true
      }
    },
    getDataByBarcode()
    {
      
      let data     = {
      'companyId'     : this.company.Id,
      'barcode'       : this.barcode   
      
      } 
      let sp = {'sp':'spPromoProductBarcodeSearch'}
      this.getData(data,sp,false)
      this.barcode = ''


    },

    
    
    
    setSelection(set)
    {
      this.items.forEach(item=>{
        item.selected = set
      })
    },
    
    async getData(data,sp,reset) {
      
      this.isOpen = []
      this.msg.title = ''      
    
      this.bt_spinner1 = true
      if(reset)
      {
        this.items   = []
      }
      
      let json    = Object.assign(data, sp)
         await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
              
              if(res.data.recordsets[0].length==0)
              { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = 'DATI INESISTENTI.'
              this.msg.type  = 1
              return
              }


              if(reset)
              {
              this.items     = res.data.recordsets[0]
              }
              else
              {
                this.items.push(res.data.recordsets[0][0])
              }
             
              

              

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner1 = false
      

    },

async getDataFromFile(barcodes) {

  
      if(barcodes.length== 0)
      {
        return
      }
      this.items = []
      this.msg.title = ''      
    
      this.bt_spinner1 = true
      const sp = {'sp':'spProductSearchFromFile'}
      const data = {'companyId':this.company.Id,'barcodes':barcodes}
      let json    = Object.assign(data, sp)
      
         await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
                            
              if(res.data.recordsets[0].length==0)
              { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = 'DATI INESISTENTI.'
              this.msg.type  = 1
              return
              }
              this.items = res.data.recordsets[0]


            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner1 = false
      

    },

    async saveData() {
    
      this.cb.title = ''

      this.bt_spinner2 = true
      
      let data = {}
      data.body = []
      

      this.filteredItems.forEach(item=>{

        if(item.selected==1)
        {
          data.body.push({'productId':item.productId,'price':this.price})            
  
        }
      })  

      var sp = {'sp':'spUpdatePriceProductPriceList'}
      
      var json    = Object.assign(data, sp)

         await api.post(json).then(res => {
          
          
          if(res.status==200)
            {
              

              this.cb.title = "AGGIORNAMENTO LISTINO"
              this.cb.msg1  = "Registrazione effettuata."
              this.cb.show  = true
              this.price    = 0
              

        
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner2 = false
      
    }

  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}



.pointer:hover
{
  _background-color   : darkorchid;
  _color              : white;
  cursor             : pointer;
}



.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }




h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}

 
 

</style>